import * as React from "react";
import { Button } from "react-bootstrap";

export default function FluidButtons(props) {
  switch (props.variant) {
    case "primary":
      return (
        <Button {...props} className="button button-primary">
          {props.children}
        </Button>
      );
    case "success":
      return (
        <Button {...props} className="button button-success">
          {props.children}
        </Button>
      );
    case "danger":
      return (
        <Button {...props} className="button button-danger">
          {props.children}
        </Button>
      );
    case "dark":
      return (
        <Button {...props} className="button button-dark">
          {props.children}
        </Button>
      );
    case "info":
      return (
        <Button {...props} className="button button-info">
          {props.children}
        </Button>
      );
    case "outlined":
      return (
        <Button {...props} className="button button-outlined">
          {props.children}
        </Button>
      );
    default:
      return (
        <Button {...props} className="button button-primary">
          {props.children}
        </Button>
      );
  }
}
